module.exports = __webpack_public_path__ + "static/city_icon_04-e20ef8ef3bfd4a5b6df47981d4f265b6.png";